import React, { FC } from "react";
import { twMerge } from "tailwind-merge";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  textClassName?: string;
}

const CustomCheckbox: FC<IProps> = ({ children, textClassName, ...props }) => {
  return (
    <>
      <div className="relative">
        <input type="checkbox" className="sr-only" {...props} />
        <div className="flex justify-center items-center w-5 h-5 box">
          {props.checked ? (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" stroke="#012169" />
              <path
                d="M15.0915 6.95197L15.0867 6.94607L15.0813 6.94057C14.9008 6.75356 14.6103 6.75315 14.4293 6.93931L9.16201 12.2296L6.58507 9.63469C6.40401 9.44841 6.11351 9.44879 5.93289 9.63584C5.7557 9.81933 5.7557 10.1087 5.93289 10.2922L5.93288 10.2923L5.93485 10.2942L8.58046 12.9583C8.73676 13.1196 8.94983 13.2 9.1473 13.2C9.36196 13.2 9.55963 13.1177 9.71406 12.9584L15.0468 7.60234C15.2436 7.4199 15.2421 7.1339 15.0915 6.95197ZM9.2327 12.3008L9.2317 12.2998C9.23206 12.3001 9.23237 12.3005 9.23269 12.3008L9.2327 12.3008Z"
                fill="#012169"
                stroke="#012169"
                strokeWidth="0.4"
              />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" fill="white" stroke="#DFE4EA" />
            </svg>
          )}
        </div>
      </div>
      <p className={twMerge("font-medium text-black whitespace-nowrap", textClassName ?? "")}>{children}</p>
    </>
  );
};
export default CustomCheckbox;
